import React from "react";
import {Popover} from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import {useNavigate} from "react-router-dom";
import {ExpandLess, ExpandMore} from "@mui/icons-material";

const SubMenuDesktop = ({title, subMenu}) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const navigate = useNavigate();

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const createNavigationHandler = (navigationLink) => () => {
        navigate(navigationLink);
    }

    return(
        <Box>
            <Button sx={{ color: '#000' }} onClick={handleClick}>
                {title}
                {open ? <ExpandLess /> : <ExpandMore />}
            </Button>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                sx={{backgroundColor: 'transparent'}}
            >
                <Box
                    style={{ display: "flex", flexDirection: "column", alignItems: "start", backgroundColor: 'white', paddingTop: 10 }}
                >
                {
                    subMenu.map(
                        (item, key) =>
                            (<Button
                                onClick={createNavigationHandler(item.link)}
                                key={key}
                                sx={{
                                    color: '#000',
                                    margin: "0 10px",
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "start"
                                }}
                            >
                                {item.title}
                            </Button>)
                    )
                }
                </Box>
            </Popover>
        </Box>
    )
}

export default SubMenuDesktop
